module.exports = __webpack_public_path__ + "img/business_shop.594180cf.svg";